export default __webpack_public_path__ + "static/media/Resume of Shihabun Shakib.f59e0b2e.pdf";